export default __webpack_public_path__ + "static/slider1-eeba1769f5a36245378a9ae6bbec0217.png";